'use client';

import { useAppStore } from '@/shared/contexts/app-wrapper/providers/app-provider';

/**
 * `undefined` while the app loads, so admins never see a member lock flash. Reads the
 * selected workspace because that is what the API checks (the page-id header).
 */
export function useIsWorkspaceAdmin(): boolean | undefined {
	const isAppLoading = useAppStore((state) => state.isAppLoading);
	const role = useAppStore((state) => state.selectedWorkspace?.currentUserRole);

	return isAppLoading ? undefined : role === 'ADMIN';
}
